
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { BaseProfileDataInterface } from '@/services/Users-profile/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class RemoveAgentDialog extends Vue {
  @Prop() private profile!: BaseProfileDataInterface;
  @Prop() private manager!: BaseProfileDataInterface;

  private visible: boolean = false;

  private created(): void {
    this.visible = true;
  }

  private get message(): string {
    return `Remove ${this.profile.firstName} ${this.profile.lastName}
    from ${this.manager.firstName} ${this.manager.lastName}'s team`;
  }

  private removeAgent(): void {
    this.$emit('remove-agent', this.profile.userId);
    this.destroyComponent();
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
